/**
 * Maintenance Mode (STEP 3) — a build-time/deploy-time flag
 * (`VITE_MAINTENANCE_MODE=true`, set at deploy, not toggleable at
 * runtime by this stage) that routes every request to a static
 * maintenance page instead of the app shell. No backend endpoint
 * backs a *runtime*-toggleable maintenance flag today — this is
 * disclosed as a real limitation (Recommended Improvement, not a
 * blocker) rather than fabricating a poll against a nonexistent
 * endpoint. Wiring this to a real runtime flag (e.g. Platform's own
 * `feature-management` module) is a natural, small follow-up once
 * that module has a frontend consumer.
 */
import type { JSX } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { env } from '@core/config/env';

export function MaintenanceGuard(): JSX.Element {
  if (env.VITE_MAINTENANCE_MODE) {
    return <Navigate to="/maintenance" replace />;
  }
  return <Outlet />;
}
